import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import {
    PAYOUT_BATCH_FAILURE,
    PAYOUT_BATCH_LOAD,
    PAYOUT_BATCH_SUCCESS,
    PAYOUT_BATCH_REJECT_SUCCESS,
    PAYOUT_BATCH_REJECT_FAILURE,
    PAYOUT_BATCH_REJECT_LOAD,
    PAYOUT_BATCH_APPROVE_SUCCESS,
    PAYOUT_BATCH_APPROVE_FAILURE,
    PAYOUT_BATCH_APPROVE_LOAD
} from './payoutBatchActions';
import { getEntityByName } from '../appEntities';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
    let newState;

    switch (action.type) {
        case PAYOUT_BATCH_LOAD:
            newState = {
                ...state,
                payoutBatch: null,
                isBatchLoading: true,
                isRejectBatchLoading: false,
                isApproveBatchLoading: false,
                batchRejectSuccess: false,
                batchApproveSuccess: false,
                rejectError: false,
                approveError: false
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCH_SUCCESS:
            newState = {
                ...state,
                isBatchLoading: false,
                payoutBatch: action.payoutBatch
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCH_FAILURE:
            newState = {
                ...state,
                payoutBatchError: action.error,
                isBatchLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCH_REJECT_LOAD:
            newState = {
                ...state,
                isBatchLoading: false,
                isRejectBatchLoading: true,
                isApproveBatchLoading: false,
                rejectError: false,
                approveError: false
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCH_REJECT_SUCCESS:
            newState = {
                ...state,
                isRejectBatchLoading: false,
                batchRejectSuccess: true
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCH_REJECT_FAILURE:
            newState = {
                ...state,
                rejectError: {
                    ...action.error,
                    message: `Failed to reject batch with error: ${get(action, 'error.message')}`
                },
                isRejectBatchLoading: false,
                batchRejectSuccess: false
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCH_APPROVE_LOAD:
            newState = {
                ...state,
                isBatchLoading: false,
                isRejectBatchLoading: false,
                isApproveBatchLoading: true,
                rejectError: false,
                approveError: false
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCH_APPROVE_SUCCESS:
            newState = {
                ...state,
                isApproveBatchLoading: false,
                batchApproveSuccess: true
            };

            return isEqual(state, newState) ? state : newState;

        case PAYOUT_BATCH_APPROVE_FAILURE:
            newState = {
                ...state,
                approveError: {
                    ...action.error,
                    message: `Failed to approve batch with error: ${get(action, 'error.message')}`
                },
                isApproveBatchLoading: false,
                batchApproveSuccess: false
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getPayoutBatchEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'payoutBatch')
);

export const getIsPayoutBatchLoading = createSelector(
    getPayoutBatchEntity,
    (entity) => get(entity, 'isBatchLoading')
);

export const getPayoutBatchError = createSelector(
    getPayoutBatchEntity,
    (entity) => get(entity, 'payoutBatchError')
);

export const getPayoutBatchErrorMessage = createSelector(
    getPayoutBatchError,
    (error) => get(error, 'message')
);

export const getPayoutBatch = createSelector(
    getPayoutBatchEntity,
    (entity) => get(entity, 'payoutBatch')
);

export const getIsRejectLoading = createSelector(
    getPayoutBatchEntity,
    (entity) => get(entity, 'isRejectBatchLoading')
);

export const getIsRejectSuccess = createSelector(
    getPayoutBatchEntity,
    (entity) => get(entity, 'batchRejectSuccess')
);

export const getRejectError = createSelector(
    getPayoutBatchEntity,
    (entity) => get(entity, 'rejectError')
);

export const getRejectErrorMessage = createSelector(
    getRejectError,
    (entity) => get(entity, 'message')
);

export const getIsApproveLoading = createSelector(
    getPayoutBatchEntity,
    (entity) => get(entity, 'isApproveBatchLoading')
);

export const getIsApproveSuccess = createSelector(
    getPayoutBatchEntity,
    (entity) => get(entity, 'batchApproveSuccess')
);

export const getApproveError = createSelector(
    getPayoutBatchEntity,
    (entity) => get(entity, 'approveError')
);

export const getApproveErrorMessage = createSelector(
    getApproveError,
    (entity) => get(entity, 'message')
);

